const EqualsIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="33"
      height="17"
      viewBox="0 0 33 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="33" height="4" rx="2" fill={color} />
      <rect y="13" width="33" height="4" rx="2" fill={color} />
    </svg>
  );
};

export default EqualsIcon;
